import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import dashjs from 'dashjs';
import DPlayer from 'dplayer';
import { default as Hls } from 'hls.js';

const Player = () => {
  const state = useLocation().state;
  useEffect(() => {
    // 通过创建节点的方式添加 script标签
    // 或 使用 react-helmet
    // 或 使用 npm安装好
    // new Array("https://cdn.jsdelivr.net/npm/hls.js@1",
    //     "https://cdn.dashjs.org/latest/dash.all.min.js",
    //     "https://cdn.jsdelivr.net/npm/dplayer@1.27.1/dist/DPlayer.min.js"
    // ).forEach(scriptUrl => {
    //     const scriptTag = document.createElement('script');
    //     scriptTag.src = scriptUrl;
    //     scriptTag.async = true;
    //     document.body.appendChild(scriptTag);
    // })

    //@ts-ignore
    const dp = new DPlayer({
      container: document.getElementById('dplayer'),
      live: false,
      autoplay: false,
      theme: '#FADFA3',
      loop: true,
      lang: 'zh-cn',
      screenshot: true,
      hotkey: true,
      airplay: false,
      chromecast: false,
      preload: 'none',
      volume: 0.7,
      playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2],
      logo: 'http://localhost/video/2/favicon.ico',
      apiBackend: null,
      preventClickToggle: true,
      mutex: true,
      video: {
        defaultQuality: 1,
        quality: [
          {
            name: 'normal',
            url: 'http://localhost/video/2/mp4/video.mp4',
            type: 'normal',
          },
          {
            name: 'dash',
            url: 'http://localhost/video/2/dash5/master.mpd',
            // type: 'dash', // https://github.com/Dash-Industry-Forum/dash.js?tab=readme-ov-file#cdn-hosted-files
            type: 'customDash',
          },
          {
            name: 'hls',
            url: 'http://localhost/video/2/hls/playlist.m3u8',
            // type: 'hls', // https://github.com/video-dev/hls.js?tab=readme-ov-file#using-hlsjs
            type: 'customHls',
          },
        ],
        type: 'auto',

        //// dash 播放源
        // url: 'http://localhost/video/2/dash5/master.mpd',
        // type: 'customDash',

        // hls 播放源
        // url: 'http://localhost/video/2/hls/playlist.m3u8',
        // type: 'customHls',

        customType: {
          customDash: function (video, player) {
            dashjs.MediaPlayer().create().initialize(video, video.src, false);
          },
          customHls: function (video, player) {
            const hls = new Hls();
            hls.loadSource(video.src);
            hls.attachMedia(video);
          },
        },

        pic: 'http://localhost/video/2/bg.jpg',
        thumbnails: 'http://localhost/video/2/bg.jpg',
      },
      pluginOptions: {
        hls: {
          // hls config
        },
        dash: {
          // dash config
        },
      },
      // subtitle: {
      //     url: 'dplayer.vtt',
      //     type: 'webvtt',
      //     fontSize: '25px',
      //     bottom: '10%',
      //     color: '#b7daff',
      // },
      // danmaku: {
      //     id: '9E2E3368B56CDBB4',
      //     api: 'https://api.prprpr.me/dplayer/',
      //     token: 'tokendemo',
      //     maximum: 1000,
      //     addition: ['https://api.prprpr.me/dplayer/v3/bilibili?aid=4157142'],
      //     user: 'DIYgod',
      //     bottom: '15%',
      //     unlimited: true,
      //     speedRate: 0.5,
      // },
      contextmenu: [
        {
          text: 'UU天堂',
          link: '/',
        },
        {
          text: '梦想远航',
          click: (player) => {
            console.log(player);
          },
        },
      ],
      highlight: [
        {
          time: 20,
          text: '这是第 20 秒',
        },
        {
          time: 120,
          text: '这是 2 分钟',
        },
      ],
    });
    dp.on('ended', function () {
      console.log('视频加载完成');
    });
  }, []);

  return (
    <div>
      <div key='dplayer'></div>
    </div>
  );
};

export default Player;
